// =============================================================================
// announcements-format.ts — Formatage local du composer/registre d'annonces (dates, identités, durées).
// =============================================================================
// WCAG 2.1 AA : les LIBELLÉS texte portent l'information ; toute couleur d'état est DOUBLÉE d'un libellé
// (ST-NFR-03). Module PUR (aucune règle métier). Découplé de cgu-format pour ne pas coupler le BC
// communication au BC legal côté UI (parité de posture, pas de dépendance croisée entre routes).

/** Formate un horodatage ISO en date/heure locale lisible (FR). `—` si null ; fallback : chaîne brute. */
export function formatDateTime(iso: string | null): string {
  if (iso === null) {
    return '—';
  }
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' });
}

/** Rend un identifiant OPAQUE (subject OIDC admin) lisible sans le résoudre : tronque + « … ». `—` si absent. */
export function formatOpaqueId(id: string | null): string {
  if (id === null || id.length === 0) {
    return '—';
  }
  return id.length <= 10 ? id : `${id.slice(0, 8)}…`;
}

/**
 * Formate une durée restante (ms) en « m min s s » lisible. Bornée à 0 (jamais négatif). Sert le compte à
 * rebours de la fenêtre de modification (renfort VISUEL ; l'échéance absolue reste le porteur accessible).
 */
export function formatRemaining(ms: number): string {
  const clamped = Math.max(0, ms);
  const totalSeconds = Math.floor(clamped / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const paddedSeconds = seconds < 10 ? `0${String(seconds)}` : String(seconds);
  return `${String(minutes)} min ${paddedSeconds} s`;
}
